<template>
  <div id="appRoot" >
    <!--<img v-if="this.$route.path != '/login'" src="./assets/beta.png" style="position: fixed;left: 1;bottom: -1rem;z-index:9999;width:150px">-->
    <v-app >
      <router-view/>
    </v-app>
  </div>
</template>

<script>
/* eslint-disable */
import AppEvents from "@/event";
import SettingService from "@/services/SettingService";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    showlayout: false,
    currentLang: {},
    languages: [],
    alert_data: {
      status: true,
      type: String,
      message: String
    },
    isVerify: false
  }),

  methods: {
    initLang() {
      for (let langKey in this.$i18n.messages) {
        this.languages[this.languages.length] = {
          code: langKey,
          title: this.$i18n.messages[langKey].lang
        };
      }

      if (localStorage.getItem("lang")) {
        this.$i18n.locale = localStorage.getItem("lang");
      }
      this.currentLang = this.$i18n.locale;
    }
  },
  created() {
    console.log(this.$route.path);
    this.initLang();
  }
};
</script>
<style>
html {
  overflow-y: auto;
}

.loading {
  pointer-events: all;
  z-index: 99999;
  border: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: fixed;
  display: table;
  background-color: rgba(0, 0, 0, 0.6);
}

.loading > i {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.spin-big {
  font-size: 50px;
  height: 50px;
  width: 50px;
}

.spin-normal {
  font-size: 35px;
  height: 35px;
  width: 35px;
}

.spin-small {
  font-size: 20px;
  height: 20px;
  width: 20px;
}

.dashboard-title {
  font-size: 1.7em;
  color: rgba(0, 0, 0, 0.6);
}
.dashboard-menu-title {
  font-size: 1em !important;
  color: rgba(0, 0, 0, 0.6);
}

.box-error:hover {
  background-color: #ffcdd2 !important;
}

.box-warning:hover {
  background-color: #ffe0b2 !important;
}

.box-success:hover {
  background-color: #c5e1a5 !important;
}

.box-info:hover {
  background-color: #bbdefb !important;
}

.box-pink:hover {
  background-color: #f8bbd0 !important;
}

.box-grey:hover {
  background-color: #bdbdbd !important;
}

/* List */
.coco-list-layout {
  padding-top: 15px;
  font-size: 16px !important;
}

.coco-list-layout .v-avatar {
  height: 64px !important;
  width: 64px !important;
}

.coco-list-label-text {
  color: #00000080 !important;
  font-weight: 400;
  padding: 4px;
}

.coco-list-label-text span {
  color: #000000 !important;
  font-weight: 400;
  padding-left: 1px;
}

.coco-list-divider {
  margin-top: 5px;
}

.coco-list-label-icon i {
  color: rgba(0, 0, 0, 0.45) !important;
  padding-bottom: 2px;
  padding-left: 2px;
  font-size: 16px;
}

.coco-list-label-icon span {
  color: rgba(0, 0, 0, 100) !important;
  font-weight: 400;
  padding-left: 6px;
}

.coco-box-shadow {
  box-shadow: 0px 0px #fff !important;
}

.coco-list-hover :hover {
  background-color: #eceff1;
  cursor: pointer;
}

.v-btn--floating.v-btn--fixed,
.v-btn--floating.v-btn--absolute {
  right: 120px;
}

/* Table Styles */

table {
  border-collapse: collapse;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table-bordered,
.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}

.table-bordered thead th {
  border-bottom-width: 2px;
}

.scroll-able {
  display: grid;
  overflow: auto;

  width: 500px;
}

.coco-sticky-table th {
  background-color: #357ca5;
  position: sticky;
  top: 0;
}

.coco-sticky-table .sticky-th-left-1 {
  top: 0;
  left: 0;
  z-index: 5 !important;
}

.coco-sticky-table .sticky-th-left-2 {
  top: 0;
  left: 199px;
  z-index: 5 !important;
}

.coco-sticky-table .sticky-td-left-1 {
  width: 200px;
  background-color: #fff;
  position: sticky;
  left: 0;
  z-index: 4 !important;
}

.coco-sticky-table .sticky-td-left-2 {
  width: 200px;
  background-color: #fff;
  position: sticky;
  left: 199px;
  z-index: 4 !important;
}

.coco-sticky-table .sticky-department {
  width: 200px;
  background-color: #fcf8e3;
  position: sticky;
  left: 0;
  z-index: 4 !important;
}
.coco-sticky-table .sticky-sum {
  width: 200px;
  background-color: #dff0d8;
  position: sticky;
  left: 0;
  z-index: 4 !important;
}

.coco-sticky-table .sticky-total-sum {
  width: 200px;
  background-color: #5ac594;
  position: sticky;
  left: 0;
  z-index: 4 !important;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 575.98px) {
  .searching_box{
    width: 158px;
  }

  .coco-list-layout {
    padding-top: 7px;
    font-size: 14px !important;
  }
  .showtitlepage{
    display: none;
  }
  .coco-list-layout .v-avatar {
    height: 48px !important;
    width: 48px !important;
  }

  .coco-list-label-text {
    color: #00000080 !important;
    font-weight: 400;
    padding: 4px;
    padding-left: 0;
  }

  .coco-list-label-text span {
    color: #000000 !important;
    font-weight: 400;
    padding-left: 2px;
  }

  .coco-list-divider {
    margin-top: 0;
  }

  .coco-list-label-icon i {
    font-size: 14px;
  }

  .v-btn--floating.v-btn--fixed,
  .v-btn--floating.v-btn--absolute {
    right: 10px !important;
  }



  .coco-sticky-table .sticky-th-left-2 {
    left: 100px;
  }

  .coco-sticky-table .sticky-td-left-1 {
    width: 100px;
  }

  .coco-sticky-table .sticky-td-left-2 {
    width: 150px;
    left: 100px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .coco-list-layout {
    padding-top: 7px;
    font-size: 14px !important;
  }

  .coco-list-layout .v-avatar {
    height: 48px !important;
    width: 48px !important;
  }

  .coco-list-label-text {
    color: #00000080 !important;
    font-weight: 400;
    padding: 4px;
    padding-left: 0;
  }

  .coco-list-label-text span {
    color: #000000 !important;
    font-weight: 400;
    padding-left: 2px;
  }

  .coco-list-divider {
    margin-top: 0;
  }

  .coco-list-label-icon i {
    font-size: 14px;
  }

  .v-btn--floating.v-btn--fixed,
  .v-btn--floating.v-btn--absolute {
    right: 10px !important;
  }


}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1800px) {

}
.v-toolbar__content {
  height: 64px !important;
}
.search_in_page {
  position: fixed !important;
  top: 54px !important;
  padding-left: 50px;
}
.searching_box {
  position: fixed !important;
  top: 0px !important;
  right: 90px !important;
  z-index: 2 !important;
  color: #fff !important;
}
.btn_show_search {
  position: fixed !important;
  top: 8px !important;
  right: 50px !important;
  z-index: 2 !important;
  color: #fff !important;
  display:none ;
}
.btn_show_pagination_mobile {
  position: fixed !important;
  left: 40%;
  bottom:50px;
}
.btn_show_pagination {
  position: fixed !important;
  left: 40%;
  bottom:50px;
}
input[name="search_item"] {
  color: #fff !important;
}
.searching_box label {
  color: #fff !important;
}
.search_in_page {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 20px;
  z-index: 2;
  display: none;
  
}
.search_in_page_flex {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 20px;
  
  
}


.filter_in_page {
  position: fixed !important;
  top: 54px !important;
  padding-left: 50px;
}
.filter_box {
  position: fixed !important;
  top: 0px !important;
  right: 90px !important;
  z-index: 2 !important;
  color: #fff !important;
}
.btn_show_filter {
  position: fixed !important;
  top: 8px !important;
  right: 10px !important;
  z-index: 2 !important;
  color: #fff !important;
}
.filter_box label {
  color: #fff !important;
}
.filter_in_page {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 20px;
  z-index: 2;
  display: none;
}
.filter_in_page_flex {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 20px;
}

.v-content{
  background: #EEEEEE !important;
}
.page-wrapper{
  background: #EEEEEE !important;
}
.background {
  background: url("assets/banner1.png") no-repeat fixed top;
  }
  .show_pagination_fixed{
  position: fixed;
  left: 10px;
  bottom: 20px;

}
</style>